export default {
  'landing.memory': '私たちと一緒に思い出を作りましょう',
  'landing.family': '家族や友人と一緒に最高の旅行を体験してください',
  'landing.point':
    'すべてのフライトと、航空券の検索、購入、払い戻しの最も簡単なプロセスを提供します',
  'landing.price': '特別割引を利用して航空券を最安値で購入する',
  'landing.point': '旅行ごとにポイントを獲得',
  'landing.buynow': '今すぐ購入',
  'landing.scotland': 'スコットランドへの旅行',
  'landing.ireland': 'アイルランドへの旅行',
  'landing.egypt': 'エジプトへの旅行',
  'landing.greece': 'ギリシャへの旅行',
  'landing.person': '何人かは行ってしまいました',
  'landing.categories': 'カテゴリ',
};
